// eslint-disable-next-line max-classes-per-file
import { Uuid } from '@ftr/contracts/type/shared'
import { HearingInstanceStateModel } from './hearings.model'

export class FetchHearingAction {
  static readonly type = '[Hearings] Fetch Hearing'

  constructor(
    readonly courtSystemId: Uuid,
    readonly hearingId: Uuid,
  ) {}
}

export class SetHearingRemoteAction {
  static readonly type = '[Hearings] Set Hearing Remote'

  constructor(
    readonly hearingId: Uuid,
    readonly hearingRemote: HearingInstanceStateModel['hearingRemote'],
  ) {}
}

export class DeleteHearingAction {
  static readonly type = '[Hearings] Delete Hearing'

  constructor(readonly hearingId: Uuid) {}
}

export class SetHearingIdAction {
  static readonly type = '[Hearings] Set Hearing Id'

  constructor(readonly hearingId: Uuid | null) {}
}
